import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';
import RendimientosSection from './RendimientosComponents/Rendimientossection';
import AreasSection from './RendimientosComponents/AreasSection';
import VainillaDialog from '../../../sharecomponents/vanilladialog';


const Rendimientos_catalogo = () => {
    const [loader, setloader] = useState(false);
    const [dialog, setdialog] = useState({ show: false });
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [rendimientos, setrendimientos] = useState({ areas: [], labores: [], rendimientos: [], um: [] });
    const [section, setsection] = useState("rendimientos");
    const areas_keys = [{ key: 'nombre', name: 'NOMBRE' }, { key: 'des', name: 'DESCRIPCIÓN' }];
    const labores_keys = [
        { key: 'labor', name: 'LABOR NOMBRE' },
        { key: 'fecha_ancla', name: 'SEMANA ASOCIADA' },
        { key: 'inicio_desde_ancla', name: 'INICIO DESDE SEMANA ASOCIADA' },
        { key: 'duracion', name: 'DURACIÓN' },
        { key: 'inventario', name: 'INVENTARIO ASOCIADO' }
    ];
    const um_keys = [{ key: 'id', name: 'FOLIO' }, { key: 'nombre', name: 'UNIDAD DE MEDIDA' }]
    useEffect(() => {
        getRendimientos();
    }, []);
    const getRendimientos = async (uri = 'catalogos/rendimientos', data = {}) => {
        setloader(true);
        let resp = await Post(uri, data);
        if (resp.estatus) setrendimientos(resp.data);
        else showDialog('Error', resp.msj);
        console.log(resp.data);
        setloader(false);
        return resp.estatus;
    }

    const area_button = (section_name) => {
        return (
            <div className='bw-150 mt-1'>
                <button className={'btn btn-sm round-m w-100 border ' + (section == section_name ? "btn-warning text-bold" : "btn-light shadow border-warning")}
                    onClick={() => setsection(section_name)}>
                    {section_name.toUpperCase()}
                    <span className='text-xs ms-2 text-blue4 text-500'>{`${rendimientos[section_name].length}`}</span>
                </button>
            </div>
        )
    }

    const update_rendimiento = async (data, update = true, deleteReg = false) => {
        if (deleteReg) return await getRendimientos('catalogos/rendimientos/delete', data);
        if (update) return await getRendimientos('catalogos/rendimientos/update', data);
        return await getRendimientos('catalogos/rendimientos/add', data);
    }

    const updateGRAL = async (data, update = true, deleteReg = false) => {
        console.log(`data send `, data, update, deleteReg);
        if (deleteReg) return await getRendimientos('catalogos/rendimientos/UmAreaLabor/delete', data);
        else if (update) return await getRendimientos('catalogos/rendimientos/UmAreaLabor/update', data);
        return await getRendimientos('catalogos/rendimientos/UmAreaLabor/add', data);
    }

    const showDialog = (title = "", body = "", tipo = "error",) => {
        setdialog({
            show: true,
            tipo: tipo,
            title: title,
            body: body,
            size: 'm',
            funct: () => { setdialog({ show: false }) }
        });
    }

    return (
        <div className='w-100 overflow bg-white m-0 p-1 overflow relative border round-m shadow-sm dosis' style={{ height: "calc(100vh - 60px)" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 p-1 bg-orange-900 ps-2 text-white text-xl round-top-m' style={{ position: "sticky", top: 0, left: 0, zIndex: 2 }}>Catálogo de rendimientos</div>
                {area_button("rendimientos")}
                {area_button("areas")}
                {area_button("um")}
                {area_button("labores")}
                {section === "rendimientos" && <RendimientosSection data={
                    rendimientos.rendimientos}
                    update={update_rendimiento}
                    inputs={
                        { areas: rendimientos.areas, labores: rendimientos.labores, um: rendimientos.um }
                    } />
                }
                {section === "areas" && <AreasSection data={rendimientos.areas} keys={areas_keys} type={section} update={updateGRAL} />}
                {section === "labores" && <AreasSection data={rendimientos.labores} keys={labores_keys} type={section} update={updateGRAL} />}
                {section === "um" && <AreasSection data={rendimientos.um} keys={um_keys} type={section} update={updateGRAL} />}
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default Rendimientos_catalogo;